import { PureComponent } from 'react';

import Icon from '@atlaskit/icon/glyph/warning';

import * as styles from './message.style';

type MessageProps = {
  header?: JSX.Element;
  messages: JSX.Element[];
};

export default class Message extends PureComponent<MessageProps> {
  render() {
    return (
      <styles.Warning>
        <styles.WarningIcon>
          <Icon label="warning" />
        </styles.WarningIcon>
        <div>
          {this.props.header && (
            <styles.Header>{this.props.header}</styles.Header>
          )}
          {this.props.messages.map((msg, idx) => (
            <p key={idx}>{msg}</p>
          ))}
        </div>
      </styles.Warning>
    );
  }
}
